import { render } from "./Step2.vue?vue&type=template&id=a507fa52&scoped=true"
import script from "./Step2.vue?vue&type=script&lang=js"
export * from "./Step2.vue?vue&type=script&lang=js"

import "./Step2.vue?vue&type=style&index=0&id=a507fa52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a507fa52"]])

export default __exports__